/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-param-reassign */
import React, {
 useState, useEffect, useCallback, useMemo,
} from 'react';
import Map, {
 Marker, Popup, Source, Layer, FlyToInterpolator,
} from 'react-map-gl';
import { circle as turfCircle, destination as turfDestination } from '@turf/turf';
import Supercluster from 'supercluster';
import WebMercatorViewport from '@math.gl/web-mercator';

import IdleIcon from './img/idle_normal_v2.svg';
import IdleExcessiveIcon from './img/idle_excessive_v2.svg';
import IdleExcusableIcon from './img/idle_excusable_v2.svg';
import MovementDetectedIcon from './img/movement_detected.svg';
import EVStandbyIcon from './img/standby_ev.svg';
import HybridStandbyIcon from './img/standby_hybrid.svg';
import CrashIcon from './img/crash.svg';
import InTowIcon from './img/intow_v2.svg';
import MovingIcon from './img/moving_v2.svg';
import StopIcon from './img/stop_v2.svg';

import MonoStop from './img/mono_stop.svg';
import MonoMoving from './img/mono_moving.svg';
import MonoIdleNormal from './img/mono_idle_normal.svg';
import MonoIdleExcessive from './img/mono_idle_excessive.svg';
import MonoIdleExcusable from './img/mono_idle_excusable.svg';
import MonoIntow from './img/mono_intow.svg';
import MonoMovementDetected from './img/mono_movement_detected.svg';
import MonoStandbyEv from './img/mono_standby_ev.svg';
import MonoStandbyHybrid from './img/mono_standby_hybrid.svg';
import MonoCrash from './img/mono_crash.svg';

import IdleDirection from './img/direction-normal-idle.svg';
import InTowDirection from './img/direction-intow.svg';
import MovingDirection from './img/Green_direction.svg';
import StopDirection from './img/Stop-direction.svg';
import IdleExcessiveDirection from './img/direction-excessive-idle.svg';
import IdleExcusableDirection from './img/direction-excusable-idle.svg';
import MovementDetectedDirection from './img/direction-movement-detected.svg';
import EVStandbyDirection from './img/direction-ev-standby.svg';
import HybridStandbyDirection from './img/direction-hybrid-standby.svg';
import CrashDirection from './img/direction-crash.svg';

// import TemperedIcon from './img/tempered.svg';
// import TemperedDirection from './img/Tempered-direction.svg';
import { clusterLayer, clusterCountLayer, unclusteredPointLayer } from './layer';
import { onDataChangeWS } from '../../config/function/websocketFlyTo';
import './mapComponent.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import { getMapStyle, defaultMapTheme, MAP_THEMES } from '../../config/function/mapStyles';

const mapboxToken = process.env.REACT_APP_MAPBOX_TOKEN;

/** Pixels; 40×40 markers — scales from 15px @ 60×60 (15×40/60). */
const HEADING_DIRECTION_PX = 10;

const headingDirectionIconStyle = {
    height: `${HEADING_DIRECTION_PX}px`,
    width: `${HEADING_DIRECTION_PX}px`,
};

const ZONE_COLOR_EXPR = ['match', ['get', 'zone'], 'A', '#12B76A', 'B', '#F79009', '#F04438'];

const MapComponent = (props) => {
  const {
    data, markerClick, markerPopUp, pointMarkerValue, assetCardDisp, clusterPoint, viewMapping, setViewMapping, oneTimeLoad, setOneTimeLoad, height = 500, width = 700, mapRefs, clusterClick, mapTheme = defaultMapTheme,
  } = props;

  // Which style URL the zone overlay has been cleared to draw against, rather than a flag set
  // once on load. The satellite toggle swaps to a Studio Standard style, and mapbox-gl v3 builds
  // those out of imports: react-map-gl re-adds every Source as soon as the root style reports
  // loaded, while the import fragments are still in flight, and addSource serializes them to
  // validate and throws "Style is not done loading". Comparing URLs makes the gate false in the
  // same render the theme changes, so the Source unmounts before that window opens.
  const mapStyle = getMapStyle(mapTheme);
  const [loadedStyle, setLoadedStyle] = useState(null);
  const isStyleLoaded = loadedStyle === mapStyle;

  // isStyleLoaded() is the check that waits for the fragments; idle backs up styledata, whose
  // last event can land while one is still loading. The map comes off the event rather than the
  // ref, which is a prop here and not this component's to rely on.
  const handleStyleLoaded = useCallback((event) => {
    const map = event?.target;
    if (map?.isStyleLoaded?.()) setLoadedStyle(mapStyle);
  }, [mapStyle]);

  // this function is for first render fitbounds
  const getBoundsForPoints = (points) => {
    // console.log(points);
      const filterPoints = points.filter((n) => n && n.length !== 0);
      if (filterPoints.length > 0) {
          const pointsLong = filterPoints.map((point) => point.longitude);

          const pointsLat = filterPoints.map((point) => point.latitude);

          const cornersLongLat = [
              [(Math.min.apply(null, pointsLong)), (Math.min.apply(null, pointsLat))],
              [(Math.max.apply(null, pointsLong)), (Math.max.apply(null, pointsLat))],
          ];

          const viewport = new WebMercatorViewport({ width: width, height: height });

          const checkCorners = (cornerLongLat) => {
              if (Array.isArray(points) && points.length > 0) {
                  return isFinite(cornerLongLat[0][0]) && isFinite(cornerLongLat[0][1]) && isFinite(cornerLongLat[1][0]) && isFinite(cornerLongLat[1][1]);
              }
          };
          // console.log('cornerLongLat', cornersLongLat);
          // console.log(checkCorners(cornersLongLat));
          if (checkCorners(cornersLongLat)) {
              const { longitude, latitude, zoom } = viewport.fitBounds(cornersLongLat, { padding: 40 });
              // if (points.length < 3) {
              //   return { longitude, latitude, zoom: 12 };
              // }
              return { longitude, latitude, zoom };
          }
      } else {
          return { longitude: 101.6869, latitude: 3.1390, zoom: 10 };
      }
  };

  // this on onLoad it will render the bounds and add into state
  useEffect(() => {
    // console.log('dataaaa', data);
    if (oneTimeLoad) {
      const boundary = getBoundsForPoints(data);
      setViewMapping({ ...boundary });
      setOneTimeLoad(false);
    }
  }, [oneTimeLoad]);

  // console.log('pointMarker', Object.keys(pointMarkerValue).length > 0 && [pointMarkerValue.latitude, pointMarkerValue.longitude]);

  // this when there is markerClick will render the bounds and add into state
  useEffect(() => {
    if (Object.keys(pointMarkerValue).length > 0) {
      // console.log(pointMarkerValue);
      onDataChangeWS(pointMarkerValue, mapRefs);
    }
  }, [pointMarkerValue]);

  const markerIcons = useMemo(() => {
      const mono = mapTheme === MAP_THEMES.MONOCHROME;
      return {
          stop: mono ? MonoStop : StopIcon,
          moving: mono ? MonoMoving : MovingIcon,
          idle: mono ? MonoIdleNormal : IdleIcon,
          idleExcessive: mono ? MonoIdleExcessive : IdleExcessiveIcon,
          idleExcusable: mono ? MonoIdleExcusable : IdleExcusableIcon,
          intow: mono ? MonoIntow : InTowIcon,
          movementDetected: mono ? MonoMovementDetected : MovementDetectedIcon,
          evStandby: mono ? MonoStandbyEv : EVStandbyIcon,
          hybridStandby: mono ? MonoStandbyHybrid : HybridStandbyIcon,
          crash: mono ? MonoCrash : CrashIcon,
      };
  }, [mapTheme]);

// this to display markerImage;
  const markerImage = (motionInference, payload) => {
    switch (motionInference) {
      case 100:
          return (
            <div className="marker-container" onClick={(e) => markerClick(e, payload)} onKeyDown={(e) => markerClick(e, payload)}>
            {
              payload.heading ? <div className="radar-box"><div className="pointers-static" style={{ transform: `rotate(${payload.heading}deg)` }}><img loading="lazy" src={StopDirection} style={headingDirectionIconStyle} alt="arrow" /></div></div> : null
            }
              <img loading="lazy" src={markerIcons.stop} alt="marker-icon" style={{ cursor: 'pointer' }} />
            </div>
          );
      case 200:
          return (
            <div className="marker-container" onClick={(e) => markerClick(e, payload)} onKeyDown={(e) => markerClick(e, payload)}>
              {
                payload.heading ? <div className="radar-box"><div className="pointers-static" style={{ transform: `rotate(${payload.heading}deg)` }}><img loading="lazy" src={MovingDirection} style={headingDirectionIconStyle} alt="arrow" /></div></div> : null
              }
              <img loading="lazy" src={markerIcons.moving} alt="marker-icon" style={{ cursor: 'pointer' }} />
            </div>
          );
      case 400:
          return (
            <div className="marker-container" onClick={(e) => markerClick(e, payload)} onKeyDown={(e) => markerClick(e, payload)}>
              {
                payload.heading ? <div className="radar-box"><div className="pointers-static" style={{ transform: `rotate(${payload.heading}deg)` }}><img loading="lazy" src={IdleDirection} style={headingDirectionIconStyle} alt="arrow" /></div></div> : null
              }
                <img loading="lazy" src={markerIcons.idle} alt="marker-icon" style={{ cursor: 'pointer' }} />
            </div>
          );
      case 450:
          return (
            <div className="marker-container" onClick={(e) => markerClick(e, payload)} onKeyDown={(e) => markerClick(e, payload)}>
              {
                payload.heading ? <div className="radar-box"><div className="pointers-static" style={{ transform: `rotate(${payload.heading}deg)` }}><img loading="lazy" src={IdleExcessiveDirection} style={headingDirectionIconStyle} alt="arrow" /></div></div> : null
              }
                <img loading="lazy" src={markerIcons.idleExcessive} alt="marker-icon" style={{ cursor: 'pointer' }} />
            </div>
          );
      case 460:
          return (
            <div className="marker-container" onClick={(e) => markerClick(e, payload)} onKeyDown={(e) => markerClick(e, payload)}>
              {
                payload.heading ? <div className="radar-box"><div className="pointers-static" style={{ transform: `rotate(${payload.heading}deg)` }}><img loading="lazy" src={IdleExcusableDirection} style={headingDirectionIconStyle} alt="arrow" /></div></div> : null
              }
                <img loading="lazy" src={markerIcons.idleExcusable} alt="marker-icon" style={{ cursor: 'pointer' }} />
            </div>
        );
      case 300:
        return (
          <div className="marker-container" onClick={(e) => markerClick(e, payload)} onKeyDown={(e) => markerClick(e, payload)}>
            {
              payload.heading ? <div className="radar-box"><div className="pointers-static" style={{ transform: `rotate(${payload.heading}deg)` }}><img loading="lazy" src={InTowDirection} style={headingDirectionIconStyle} alt="arrow" /></div></div> : null
            }
              <img loading="lazy" src={markerIcons.intow} alt="marker-icon" style={{ cursor: 'pointer' }} />
          </div>
        );
      case 150:
        return (
          <div className="marker-container" onClick={(e) => markerClick(e, payload)} onKeyDown={(e) => markerClick(e, payload)}>
            {
              payload.heading ? <div className="radar-box"><div className="pointers-static" style={{ transform: `rotate(${payload.heading}deg)` }}><img loading="lazy" src={MovementDetectedDirection} style={headingDirectionIconStyle} alt="arrow" /></div></div> : null
            }
              <img loading="lazy" src={markerIcons.movementDetected} alt="marker-icon" style={{ cursor: 'pointer' }} />
          </div>
        );
      case 800:
        return (
          <div className="marker-container" onClick={(e) => markerClick(e, payload)} onKeyDown={(e) => markerClick(e, payload)}>
            {
              payload.heading ? <div className="radar-box"><div className="pointers-static" style={{ transform: `rotate(${payload.heading}deg)` }}><img loading="lazy" src={EVStandbyDirection} style={headingDirectionIconStyle} alt="arrow" /></div></div> : null
            }
              <img loading="lazy" src={markerIcons.evStandby} alt="marker-icon" style={{ cursor: 'pointer' }} />
          </div>
        );
      case 850:
        return (
          <div className="marker-container" onClick={(e) => markerClick(e, payload)} onKeyDown={(e) => markerClick(e, payload)}>
            {
              payload.heading ? <div className="radar-box"><div className="pointers-static" style={{ transform: `rotate(${payload.heading}deg)` }}><img loading="lazy" src={HybridStandbyDirection} style={headingDirectionIconStyle} alt="arrow" /></div></div> : null
            }
              <img loading="lazy" src={markerIcons.hybridStandby} alt="marker-icon" style={{ cursor: 'pointer' }} />
          </div>
        );
      case 700:
        return (
          <div className="marker-container" onClick={(e) => markerClick(e, payload)} onKeyDown={(e) => markerClick(e, payload)}>
            {
              payload.heading ? <div className="radar-box"><div className="pointers-static" style={{ transform: `rotate(${payload.heading}deg)` }}><img loading="lazy" src={CrashDirection} style={headingDirectionIconStyle} alt="arrow" /></div></div> : null
            }
              <img loading="lazy" src={markerIcons.crash} alt="marker-icon" style={{ cursor: 'pointer' }} />
          </div>
        );
      default:
          return null;
    }
  };

  // console.log('pointmarkervalue', pointMarkerValue);

  const reducer = (value) => {
    const featureCollection = {
      type: 'FeatureCollection',
      features: value.map((e) => {
        const conatiner = {
          type: 'Feature',
          properties: e,
          geometry: {
            type: 'Point',
            coordinates: [e.longitude, e.latitude],
          },
        };
        return conatiner;
      }),
    };
    return featureCollection;
  };

  const index = useMemo(() => new Supercluster({ radius: 75, maxZoom: 16 }).load(reducer(data).features), [data]);

  const bounds = mapRefs?.current && mapRefs?.current.getMap() ? mapRefs?.current.getMap().getBounds().toArray().flat() : [1, 1, 1, 1];

  const clusters = index.getClusters(bounds, viewMapping.zoom);

  // console.log(clusters);

  // console.log(clusters.some((e) => e.properties.deviceOid === '64b604e8fca5ef0c8b05cc2b'));

  const moveCamera = (longitude, latitude, cluster) => {
    if (clusterClick && clusterClick === true) {
      const expansionZoom = index.getClusterExpansionZoom(
        cluster.properties.cluster_id,
      );
      mapRefs.current.flyTo({
        center: [longitude, latitude], zoom: expansionZoom, duration: 700,
      });
    }
  };

  const selectedPopupLabel = pointMarkerValue?.assetName || pointMarkerValue?.deviceSerial || '';
  const hasPopupCoordinates = Number.isFinite(pointMarkerValue?.longitude) && Number.isFinite(pointMarkerValue?.latitude);
  const shouldShowPopup = clusters.some((e) => e.properties.deviceOid === pointMarkerValue?.deviceOid)
    && hasPopupCoordinates
    && selectedPopupLabel.trim() !== '';

  const spanZonesGeoJSON = useMemo(() => {
    if (!pointMarkerValue?.bleSpan || !Number.isFinite(pointMarkerValue?.longitude) || !Number.isFinite(pointMarkerValue?.latitude)) return null;
    const center = [pointMarkerValue.longitude, pointMarkerValue.latitude];
    const circleOpts = { steps: 64, units: 'kilometers' };
    return {
      type: 'FeatureCollection',
      features: [
        { ...turfCircle(center, 0.015, circleOpts), properties: { zone: 'C' } },
        { ...turfCircle(center, 0.010, circleOpts), properties: { zone: 'B' } },
        { ...turfCircle(center, 0.003, circleOpts), properties: { zone: 'A' } },
        { ...turfDestination(center, 0.015, 0, { units: 'kilometers' }), properties: { zone: 'C', label: 'C' } },
        { ...turfDestination(center, 0.010, 0, { units: 'kilometers' }), properties: { zone: 'B', label: 'B' } },
        { ...turfDestination(center, 0.003, 0, { units: 'kilometers' }), properties: { zone: 'A', label: 'A' } },
      ],
    };
  }, [pointMarkerValue?.latitude, pointMarkerValue?.longitude, !!pointMarkerValue?.bleSpan]);

  return (
      <Map
        {...viewMapping}
        ref={mapRefs}
        onMove={(event) => setViewMapping(event.viewState)}
        onLoad={handleStyleLoaded}
        onStyleData={handleStyleLoaded}
        onIdle={handleStyleLoaded}
        // mapStyle="mapbox://styles/asiamobiliti/cmmiuekib00e701raeahf215b"
        mapStyle={mapStyle}
        mapboxAccessToken={mapboxToken}
        width="100%"
        height="100%"
      >
        {isStyleLoaded && spanZonesGeoJSON && (
          <Source id="span-zones" type="geojson" data={spanZonesGeoJSON}>
            <Layer
              id="span-zones-fill"
              type="fill"
              filter={['==', ['geometry-type'], 'Polygon']}
              paint={{ 'fill-color': ZONE_COLOR_EXPR, 'fill-opacity': 0.15 }}
            />
            <Layer
              id="span-zones-line"
              type="line"
              filter={['==', ['geometry-type'], 'Polygon']}
              paint={{
                'line-color': ZONE_COLOR_EXPR,
                'line-width': 2,
                'line-dasharray': [4, 3],
                'line-opacity': 0.8,
              }}
            />
            <Layer
              id="span-zones-label"
              type="symbol"
              filter={['==', ['geometry-type'], 'Point']}
              layout={{
                'text-field': ['get', 'label'],
                'text-size': 12,
                'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
                'text-anchor': 'bottom',
              }}
              paint={{
                'text-color': ZONE_COLOR_EXPR,
                'text-halo-color': '#ffffff',
                'text-halo-width': 1.5,
              }}
            />
          </Source>
        )}
        {
          clusters && clusters.map((cluster) => {
            const [longitude, latitude] = cluster.geometry.coordinates;
            const {
              cluster: isCluster,
              point_count: pointCount,
            } = cluster.properties;

            if (isCluster) {
              return (
                  <Marker
                    key={cluster.properties.cluster_id}
                    latitude={latitude}
                    longitude={longitude}
                  >
                    <div
                      key={cluster.properties.cluster_id}
                      className="cluster-marker"
                      style={{
                          width: `${10 + (pointCount / cluster.properties.point_count) * 20}px`,
                          height: `${10 + (pointCount / cluster.properties.point_count) * 20}px`,
                      }}
                      onClick={() => moveCamera(longitude, latitude, cluster)}
                    >
                      {pointCount}
                    </div>
                  </Marker>
              );
            }

            return (
              <>
                <Marker
                  key={cluster.properties.deviceOid}
                  longitude={longitude}
                  latitude={latitude}
                >
                  {markerImage(cluster.properties.motionInference, cluster.properties)}
                </Marker>
              </>
            );
          })
        }
        {shouldShowPopup && (
          <Popup
            style={{
              opacity: '60%',
            }}
            longitude={pointMarkerValue.longitude}
            latitude={pointMarkerValue.latitude}
            closeButton={false}
            closeOnClick={false}
          >
            {selectedPopupLabel}
          </Popup>
        )}
        <style>
          {
            `
              .mapboxgl-popup-content {
                box-shadow: 0rem 0.75rem 1rem -0.875rem rgba(16, 24, 40, 0.08), 0rem 0.25rem 0.375rem -0.125rem rgba(16, 24, 40, 0.03);
                border-radius: 0.5rem;
                font-weight: 600;
                font-size: 0.75rem;
                width: 100%;
                text-align: center;
                padding: 0.75rem 1rem;
              }
            `
          }
        </style>
      </Map>
  );
};

export default MapComponent;
